module.exports = __webpack_public_path__ + "static/media/walk.a93e3c68.png";